import {
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';

export type BookingStatus = 'pending' | 'approved' | 'rejected';

/** Branca / unità per cui si prenota la sede */
export const BRANCHE = [
  'L/C',
  'E/G',
  'R/S',
  'Co.Ca.',
  'Gruppo',
  'Altro',
] as const;
export type Branca = (typeof BRANCHE)[number];

/** Etichette UI (valore salvato resta quello in BRANCHE) */
export const BRANCA_LABELS: Record<Branca, string> = {
  'L/C': 'L/C',
  'E/G': 'E/G',
  'R/S': 'R/S',
  'Co.Ca.': 'Co.Ca.',
  Gruppo: 'Gruppo',
  Altro: 'Altro (specificare sotto)',
};

export function isBranca(value: string): value is Branca {
  return (BRANCHE as readonly string[]).includes(value);
}

export const REGOLAMENTO_PDF_PATH = `${process.env.PUBLIC_URL || ''}/Regolamento%20Sede%20di%20Zona.pdf`;

/** Validazione cellulare internazionale (default paese IT). */
export function isValidPhone(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;
  try {
    return isValidPhoneNumber(trimmed, 'IT');
  } catch {
    return false;
  }
}

/** Input: consente +, cifre, spazi, trattini e parentesi. */
export function sanitizePhoneInput(value: string): string {
  return value.replace(/[^\d+()\s-]/g, '').slice(0, 25);
}

/** Normalizza in E.164 (es. +393455734683) se possibile. */
export function normalizePhone(value: string): string {
  const trimmed = value.trim();
  const parsed = parsePhoneNumberFromString(trimmed, 'IT');
  if (parsed?.isValid()) return parsed.format('E.164');
  return trimmed;
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 200;
}

export interface Booking {
  id: string;
  gruppoScout: string;
  /** Per che branca si prenota */
  branca: Branca | '';
  /** Ragazzi previsti (0 ammessi) */
  numeroRagazzi: number;
  /** Adulti previsti (almeno 1) */
  numeroAdulti: number;
  referenteNome: string;
  telefono: string;
  email: string;
  /** YYYY-MM-DD — inizio periodo */
  startDate: string;
  /** YYYY-MM-DD — fine periodo (inclusiva come giorno, con endTime) */
  endDate: string;
  /** HH:mm — inizio (step 30 min) */
  startTime: string;
  /** HH:mm — fine (step 30 min, esclusiva come istante di chiusura) */
  endTime: string;
  altreInfo: string;
  status: BookingStatus;
  /** ID evento Google Calendar (Apps Script / CalendarApp) */
  googleCalendarEventId?: string;
  createdAt: number;
  updatedAt: number;
}

export type BookingInput = Omit<Booking, 'id' | 'status' | 'createdAt' | 'updatedAt'>;
